import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createBusinessProperties, getMyBusinessProperties, updateBusinessProperties } from '@wix/ambassador-ai-scheduling-assistant-v1-business-properties/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { BusinessPropertiesClientBase } from './BusinessPropertiesClientBase';
export class BusinessPropertiesClient extends HttpBaseClient(BusinessPropertiesClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createBusinessPropertiesImpl", createBusinessProperties);
    _defineProperty(this, "getMyBusinessPropertiesImpl", getMyBusinessProperties);
    _defineProperty(this, "updateBusinessPropertiesImpl", updateBusinessProperties);
  }
}
//# sourceMappingURL=BusinessPropertiesClientHttp.js.map